import { useState, useEffect } from "react";
import { login as loginApi } from "../services/authService";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import "../css/Login.css";
import logo from "../images/Logo.png";
import api from "../api/axios";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const navigate = useNavigate();
  const { login } = useAuth();

  // Auto hide error message
  useEffect(() => {
    if (!errorMsg) return;

    const timer = setTimeout(() => {
      setErrorMsg("");
    }, 2000);

    return () => clearTimeout(timer);
  }, [errorMsg]);

  const submit = async () => {
    if (loading) return;

    setLoading(true);
    setErrorMsg("");

    if (!username.trim()) {
      setErrorMsg("Please Enter Username");
      setLoading(false);
      return;
    }

    if (!password.trim()) {
      setErrorMsg("Please Enter Password");
      setLoading(false);
      return;
    }

    try {
      const result = await loginApi({
        username: username.trim(),
        password: password.trim(),
      });

      // Save Login Details
      login(result.token, result.roleName);

      localStorage.setItem("username", result.userName);
      localStorage.setItem("counterId", result.counterId);
      localStorage.setItem("id", result.id);
      localStorage.setItem("userId", result.userId);
      localStorage.setItem("roleName", result.roleName);

      // Load Role Menus
      const menuRes = await api.get(`/Menu/${result.id}`);
      localStorage.setItem("menus", JSON.stringify(menuRes.data));

      // Role Wise Navigation
      switch (result.roleName) {
        case "Admin":
        case "Company":
          navigate("/Dashboard");
          break;

        case "Counter":
          navigate("/CounterPanel");
          break;

        case "Display":
          navigate("/DisplayBoardcounterWise");
          break;

        default:
          navigate("/GenerateToken");
          break;
      }
    } catch (error) {
      console.error(error);
      setErrorMsg("Invalid Username or Password");
    } finally {
      setLoading(false);
    }
  };

  // Press Enter to Login
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      submit();
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">

        <div className="logo-section text-center">
          <img src={logo} alt="Logo" className="logo" />
          <span>Municipal Corporation Ambala</span>
        </div>

        {errorMsg && (
          <div className="alert alert-danger text-center">
            {errorMsg}
          </div>
        )}

        <div className="mb-3">
          <label className="form-label">Username</label>
          <input
            type="text"
            className="custom-input"
            placeholder="Enter Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyDown={handleKeyDown}
            autoComplete="username"
          />
        </div>

        <div className="mb-4">
          <label className="form-label">Password</label>
          <input
            type="password"
            className="custom-input"
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKeyDown}
            autoComplete="current-password"
          />
        </div>

       <div className="text-center">
          <button
            className="login-btn"
            onClick={submit}
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Logging in...
              </>
            ) : (
              "Login"
            )}
          </button>
        </div>
      </div>

      <div className="footer-text">
        © 2026 - Municipal Corporation Ambala
      </div>
    </div>
  );
}

export default Login;